import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency, logComponentLoad, logDashboardAction } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import Select from 'react-select';
import { SingleDatePicker } from 'react-dates';

import { getShirtTypesToDisplay } from './ApiUtils'

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });


class EditInHouseProjectCosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            description: '',
            shirtTypeChoices: [],
            loading: false,
            qty: '',
            cost: '',
            customerId: '',
            shirtTypeId: '',
            project: '',
            algoliaUser: ''
        }
    }

    componentDidMount() {
        console.log("edIpc1 ++++++++++ searchNow componentDidMount");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("edIpc12 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("edIpc12 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("edIpc13 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    // this.getApiDetails();
                    //getShirtTypes(this.loadShirtTypes);
                    getShirtTypesToDisplay(this.setShirtTypeDropDown, "large_projects");
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }


    setAdminResult = (returnObject) => {
        // console.log("edIpc12 ++++++ addx294 setAdminResult");
        // console.log("edIpc13 returnObject:" + JSON.stringify(returnObject, null, 3));

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        logComponentLoad(returnObject, "EditInHouseProjectCosts");

        if (returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("editProjectCosts")) {
            if (this.props.match.params.inHouseCostId) {

               this.getASingleInHouseCost();

            } else {
                alert("edIpc13 No inHouseCostId Sent")

            }
        }else{
            alert("loading error ex4")
        }
    }

    setShirtTypeDropDown = (shirtTypes) => {
        console.log("edIpc13 +++++++:setShirtTypeDropDown");
        //console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            loading: false,
            shirtTypeChoices: shirtTypes
        })

    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    getASingleInHouseCost = () => {
        console.log("edIpc14 ++++++++:getASingleInHouseCost");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getASingleInHouseCost', {
            apiKey: "asdfs&3asdf^",
            inHouseCostId: this.props.match.params.inHouseCostId,
            enteredBy: this.state.user.email
        })
            .then((response) => {

                this.setState({ loading: false })
                console.log("edIpc141 :"+JSON.stringify(response.data,null,3));

                if (response.data.inHouseCost) {
                    console.log("edIpc142 response.data.inHouseCost:"+JSON.stringify(response.data.inHouseCost,null,3));

                    this.setState({
                        idlargeprojectinhousecosts: response.data.inHouseCost.idlargeprojectinhousecosts,
                        qty: response.data.inHouseCost.qty,
                        amount: response.data.inHouseCost.amount,
                        shirtTypeId: response.data.inHouseCost.itemtypedone.idshirtypes,
                        project: response.data.inHouseCost.largeprojects,
                        
                    })
                } else {
                    console.log("edIpc143 inHouseCost does not exists");
                }

            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    resetFeilds = () => {
        this.setState({
            description: '',
            qty: '',
            cost: '',
            shirtTypeId: ''
        })
    }


    udpateInHouseCost = () => {
        console.log("++++++++:sendCustomer");
        console.log("edIpc16 inHouseCostId:" + this.state.inHouseCostId)
        console.log("edIpc161 qty:" + this.state.qty)
        console.log("edIpc162 shirtTypeId:" + this.state.shirtTypeId)
        console.log("edIpc163 amount:" + this.state.amount)
        console.log("edIpc164 enteredBy:" + this.state.user.email)

        

       if (this.state.qty == '') {
            alert("No qty Entered")
        } else if (this.state.amount == '') {
            alert("No cost Entered")
        } else if (this.state.shirtTypeId == '') {
            alert("No Shirt Type shirtTypeId")
        } else if (this.state.user.email == '') {
            alert("No Entered By Provided")
        } else {
            console.log("sending data..udpateInHouseCost");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'udpateInHouseCost', {
                apiKey: "asdf^43",
                inHouseCostId: this.props.match.params.inHouseCostId,
                qty: this.state.qty,
                amount: this.state.amount,
                enteredBy: this.state.user.email,
                shirtTypeId: this.state.shirtTypeId
            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. cost modified");

                        this.resetFeilds();
                        this.setState({
                            loading: false,
                            // showProjectCosts: true,
                            // projectCosts: response.data.projectCosts
                        })


                        //alert(response.data.message);
                       history.push("/dashboard/viewLargeProject/" + this.state.project.idlargeprojects);
                    } else {
                        console.log("FAILED");
                        this.setState({
                            loading: false,

                        })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    deleteInHouseCost = () => {
        console.log("delhpc31 ++++++++:deleteInHouseCost");
        console.log("delhpc312 this.state.user.email:"+this.state.user.email);

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'deleteInHouseCost', {
            apiKey: "asdfasdf",
            inHouseCostId: this.props.match.params.inHouseCostId,
            enteredBy: this.state.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log("delhpc313:"+JSON.stringify(response.data,null,3));

                if (response.data.result) {
                    console.log("delhpc314: inhouse costs:" + JSON.stringify(response.data.inhouseCosts, null, 3))

                    history.push("/dashboard/viewLargeProject/" + this.state.project.idlargeprojects);
                } else {
                    console.log("delhpc315 FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    render() {

   

        const shirtTypeDropdown = this.state.shirtTypeChoices.length > 0
            ? <Select
                name="form-field-name"
                value={this.state.shirtTypeId}
                options={this.state.shirtTypeChoices}
                onChange={this.handleDropDownChanges}
                searchable={false}
                clearable={false}
            />
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("editProjectCosts")
            ? <div>
                <h1>EDIT {this.state.project.name} </h1>
                <h1>Cost Id: {this.props.match.params.inHouseCostId}</h1>


                <Form size='large' onSubmit={this.udpateInHouseCost}>
                    <Segment stacked>

                        <label>Quantity</label>
                        <Form.Input
                            fluid
                            icon='blind'
                            iconPosition='left'
                            placeholder='Qty'
                            type='number'
                            name="qty"
                            value={this.state.qty}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Enter Amount</label>
                        <Form.Input
                            fluid
                            icon='blind'
                            iconPosition='left'
                            placeholder='Amount'
                            type='number'
                            name="amount"
                            value={this.state.amount}
                            onChange={this.handleTextInputChange}
                        />

                        <br />
                        <label>Select Items</label>
                        {shirtTypeDropdown}

                        
                        <Button color='brown' fluid>UPDATE COSTS</Button>
                    </Segment>
                </Form>

                <Button fluid color='red' onClick={this.deleteInHouseCost}> DELETE COST </Button>

            </div>
            : <h4>loading error a75</h4>

        //const projectCosts = this.state.showProjectCosts && this.state.projectId && !this.props.projectId
        // const projectCosts = this.props.projectId
        //     ? <ViewLargeProjectCosts projectId={this.props.projectId} projectCosts={this.state.projectCosts} />
        //     : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

                {wholeUI}


            </div>
        );
    }
}

export default EditInHouseProjectCosts;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/EditInHouseProjectCosts.js